import { Controller } from "@hotwired/stimulus"
import data from "@emoji-mart/data"
import { Picker } from "emoji-mart"
import { isHTMLElement } from "~/types/types.util"

interface Emoji {
  native: string
}

// Connects to data-controller="emoji-picker"
export default class EmojiPickerController extends Controller<HTMLElement> {
  static targets = ["input", "pickerContainer"]

  declare readonly inputTarget: HTMLInputElement
  declare readonly pickerContainerTarget: HTMLElement

  connect() {
    const { height, perLine } = this.#pickerDimensions()

    const picker = new Picker({
      data,
      onEmojiSelect: this.#selectEmoji.bind(this),
      previewPosition: "none",
      perLine,
    })

    if (isHTMLElement(picker)) {
      picker.style.height = `${height}px`
      this.pickerContainerTarget.replaceChildren(picker)
    }
  }

  reset() {
    this.inputTarget.value = ""
    this.dispatch("change", {})
  }

  #selectEmoji(emoji: Emoji) {
    this.inputTarget.value = emoji.native
    this.dispatch("change", { detail: { emoji } })
  }

  #pickerDimensions() {
    const height = Math.max(this.pickerContainerTarget.clientHeight, 400)
    const availableWidth = this.pickerContainerTarget.clientWidth
    const defaultIconSize = 36
    const perLine = Math.max(6, Math.floor(availableWidth / defaultIconSize))

    return { height, perLine }
  }
}
